export default "__VITE_ASSET__BQRJ$ONB__"